import {
  QUERY_KEYS as SHARED_QUERY_KEYS,
  MUTATION_KEYS as SHARED_MUTATION_KEYS,
} from '@avanta/shared/constants/common';

export const QUERY_KEYS = {
  ...SHARED_QUERY_KEYS,
  FETCH_TREATMENTS: 'FETCH_TREATMENTS',
  FETCH_ENTERPRISE_CONTRACTS: 'FETCH_ENTERPRISE_CONTRACTS',
  FETCH_PATIENT_ACTIVE_RECORD: 'FETCH_PATIENT_ACTIVE_RECORD',
  FETCH_PATIENT_RECORDS: 'FETCH_PATIENT_RECORDS',
  FETCH_PATIENT_HEALTH_CENTER: 'FETCH_PATIENT_HEALTH_CENTER',
};

export const MUTATION_KEYS = {
  ...SHARED_MUTATION_KEYS,
  CREATE_EMPLOYEES: 'CREATE_EMPLOYEES',
  UPLOAD_DOCUMENT: 'UPLOAD_DOCUMENT',
};

export const DOCUMENT_CATEGORIES = {
  REFERRAL: 'REFERRAL',
  AUTHORIZATION: 'AUTHORIZATION',
  REPORT: 'REPORT',
  OTHER: 'OTHER',
} as const;
